import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ProfileComponent } from './components/profile-container/profile.component'
import { SharedModule } from '@app/shared/shared.module'
import { ProfileInfoComponent } from './components/profile-info/profile-info.component'
import { ProfileInfoGeneralComponent } from './components/profile-info-general/profile-info-general.component'
import { ProfileInfoGroupsComponent } from './components/profile-info-groups/profile-info-groups.component'
import { ProfileInfoMeetingsComponent } from './components/profile-info-meetings/profile-info-meetings.component'
import { ProfileInfoQandaComponent } from './components/profile-info-qanda/profile-info-qanda.component'
import { ProfileInfoStreaksComponent } from './components/profile-info-streaks/profile-info-streaks.component'
import { ProfileInfoStatusComponent } from './components/profile-info-status/profile-info-status.component'
import { ProfileInfoSessionsComponent } from './components/profile-info-sessions/profile-info-sessions.component'
import { UserActionsModule } from '@app/user-actions/user-actions.module'
import { MaterialModule } from '@app/material/material.module'
import { AppBarComponent } from '@app/shared/components/app-bar/app-bar.component'

@NgModule({
    declarations: [
        ProfileComponent,
        ProfileInfoComponent,
        ProfileInfoGeneralComponent,
        ProfileInfoGroupsComponent,
        ProfileInfoMeetingsComponent,
        ProfileInfoQandaComponent,
        ProfileInfoStreaksComponent,
        ProfileInfoStatusComponent,
        ProfileInfoSessionsComponent,
    ],
    exports: [ProfileComponent],
    imports: [CommonModule, MaterialModule, SharedModule, UserActionsModule, AppBarComponent],
})
export class SharedProfileModule {}
